var map = {
	"./yopy1.png": 7365,
	"./yopy2.png": 8590,
	"./yopy3.png": 8583,
	"./yopy4.png": 8968,
	"./yopy5.png": 1681,
	"./yopy6.png": 2698,
	"./yopy7.png": 3459,
	"./yopy8.png": 8164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9787;